import React, { useState, useEffect } from "react";
import { NAV_ITEMS } from "../config/siteConfig";
import { scrollToSection } from "../config/utils";

// ══════════════════════════════════════════════════════════════
// ⚠️  À CHANGER : remplacez le logo par le vôtre
// Décommentez la ligne ci-dessous et commentez le logo "P"
// ══════════════════════════════════════════════════════════════
import Logo from "../assets/justLogo.svg";

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/80 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
        {/* ── Logo ── */}
        <button
          onClick={() => scrollToSection("hero")}
          className="flex items-center gap-3"
        >
          <img src={Logo} alt="logo" className="h-16" />
          {/* <div className="w-10 h-10 rounded-full bg-gradient-to-br from-amber-500 to-amber-700 flex items-center justify-center text-black font-bold text-lg">
            P
          </div> */}
          {/* <span className="text-xl tracking-widest uppercase font-display text-gold">
            Prestige
          </span> */}
        </button>

        {/* ── Desktop Nav ── */}
        <ul className="hidden lg:flex items-center space-between gap-1">
          {NAV_ITEMS.map((item) => (
            <li key={item.target}>
              <button
                onClick={() => scrollToSection(item.target)}
                className="px-5 py-2 text-sm tracking-wider uppercase text-zinc-400 hover:text-white transition-colors duration-300 relative group"
              >
                {item.label}
                <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-px bg-amber-500 group-hover:w-3/4 transition-all duration-300" />
              </button>
            </li>
          ))}
          <li className="ml-4">
            <button
              onClick={() => scrollToSection("contact")}
              className="px-6 py-2.5 text-sm tracking-wider uppercase border border-amber-600/50 text-amber-500 hover:bg-amber-600 hover:text-black transition-all duration-300 rounded-sm"
            >
              Réserver
            </button>
          </li>
        </ul>

        {/* ── Hamburger ── */}
        <button
          className="lg:hidden flex flex-col gap-1.5 p-2 z-50"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span
            className={`w-6 h-0.5 bg-white transition-all duration-300 ${
              menuOpen ? "rotate-45 translate-y-2" : ""
            }`}
          />
          <span
            className={`w-6 h-0.5 bg-white transition-all duration-300 ${
              menuOpen ? "opacity-0" : ""
            }`}
          />
          <span
            className={`w-6 h-0.5 bg-white transition-all duration-300 ${
              menuOpen ? "-rotate-45 -translate-y-2" : ""
            }`}
          />
        </button>
      </div>

      {/* ── Mobile Menu ── */}
      <div
        className={`lg:hidden fixed inset-0 bg-black/95 backdrop-blur-xl flex flex-col items-center justify-center gap-8 transition-all duration-500 ${
          menuOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
      >
        {NAV_ITEMS.map((item) => (
          <button
            key={item.target}
            onClick={() => {
              scrollToSection(item.target);
              setMenuOpen(false);
            }}
            className="text-2xl tracking-widest uppercase text-zinc-300 hover:text-amber-500 transition-colors"
          >
            {item.label}
          </button>
        ))}
      </div>
    </nav>
  );
};

export default Navbar;
